import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import reactOnClickOutside from 'react-onclickoutside';

import themeable from 'zignal-landscape/lib/themeable';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import Button from 'zignal-landscape/lib/Button';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';
import SortIcon from 'zignal-landscape/lib/Icon/SortIcon';

import { getSortOptions, ORDER_OPTIONS } from './SortOptions';

const selectStyles = {
  singleValue: (base) => ({
    ...base,
    padding: 0,
    lineHeight: 'inherit'
  })
};

const ReadingListStoriesSortDropdown = ({
  onSortList,
  isMediaScoreEnabled,
  styles,
  sortByDefault = null,
  orderByDefault = null
}) => {
  const sortOptions = getSortOptions(isMediaScoreEnabled);
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [sortBy, setSortBy] = useState(sortByDefault);
  const [orderBy, setOrderBy] = useState(orderByDefault);

  function handleButtonClick(e) {
    e.preventDefault();
    setIsMenuOpened(!isMenuOpened);
  }

  function handleApplyClick(e) {
    e.preventDefault();
    if (sortBy && orderBy) {
      setIsMenuOpened(false);
      onSortList(sortBy, orderBy);
    }
  }

  function handleSortByChange(option) {
    setSortBy(option);
  }

  function handleOrderByChange(option) {
    setOrderBy(option);
  }

  ReadingListStoriesSortDropdown.handleClickOutside = () => setIsMenuOpened(false);
  return (
    <div>
      <ToolTip position="top" tooltipText="Sort Stories">
        <div className={isMenuOpened ? '' : styles.buttonWrapper}>
          <Button onClick={handleButtonClick} style={{ padding: '5px 7px', marginLeft: '5px' }} active={isMenuOpened}>
            <SortIcon />
          </Button>
        </div>
      </ToolTip>
      <ul
        className={classnames([
          'dropdown-menu',
          styles.menu,
          {
            [styles.menuOpened]: isMenuOpened
          }
        ])}
      >
        <li className={styles.liSortBy}>
          <Label inline htmlFor={'stories-sort-by'}>
            Sort By
          </Label>
          <Select
            key="stories-sort-by"
            id="stories-sort-by"
            options={sortOptions}
            isSearchable={false}
            value={sortBy}
            onChange={handleSortByChange}
            selectStyles={selectStyles}
          />
        </li>
        <li className={styles.liOrderBy}>
          <Label inline htmlFor={'stories-order-by'}>
            Order By
          </Label>
          <Select
            key="stories-order-by"
            id="stories-order-by"
            options={ORDER_OPTIONS}
            isSearchable={false}
            value={orderBy}
            onChange={handleOrderByChange}
            selectStyles={selectStyles}
          />
        </li>
        <li className={styles.liApply}>
          <Button onClick={handleApplyClick} disabled={!sortBy || !orderBy}>Apply</Button>
        </li>
      </ul>
    </div>
  );
};

ReadingListStoriesSortDropdown.propTypes = {
  onSortList: PropTypes.func.isRequired,
  isMediaScoreEnabled: PropTypes.bool,
  sortByDefault: PropTypes.string,
  orderByDefault: PropTypes.string,
  styles: PropTypes.object.isRequired
};

const clickOutsideConfig = {
  handleClickOutside: () => ReadingListStoriesSortDropdown.handleClickOutside
};

export default themeable(reactOnClickOutside(ReadingListStoriesSortDropdown, clickOutsideConfig));
